import React from 'react'

import { COLORS } from '@btime/constants'
import Container from '../../../../components/structure/Container'

const styles = {
  root: {
    backgroundColor: COLORS.light3,
    padding: '3rem',
    position: 'relative'
  },

  content: {
    backgroundColor: COLORS.white,
    // padding: '1cm',
    borderRadius: '5px',
    minHeight: '21cm',
    overflow: 'hidden'
  }
}

const Preview = ({ children, link }) => (
  <div style={styles.root}>
    <Container maxWidth="29.7cm">
      <div style={styles.content}>{children}</div>
    </Container>
  </div>
)

export default Preview
